import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// https://router.vuejs.org/guide/advanced/lazy-loading.html#lazy-loading-routes
// setting the imports outside the route
const ESHealth = () =>
  import(/* webpackChunkName: "es-health" */ "@/views/ESHealth.vue");
const GO = () => import(/* webpackChunkName: "go" */ "@/views/Go.vue");

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "go",
      component: GO
    },
    {
      path: "/health/elasticsearch",
      name: "eshealth",
      component: ESHealth
    }
  ]
});
